<template>
  <el-aside class="aside" :width="isTablet ? '0px' : '98px'">
    <div class="aside__logo">
      <img src="/img/logo-small.svg" alt="" />
    </div>
    <ul class="aside__menu">
      <li class="aside__menu-item">
        <router-link
          :to="!storeAuth.isCourier ? '/' : `/employee/${storeAuth.user.id}`"
        >
          <TheIcons :name="storeAuth.isCourier ? 'user' : 'list'" />
        </router-link>
      </li>
      <li class="aside__menu-item">
        <router-link
          :to="{ name: !storeAuth.isAdmin ? 'Work Logs' : 'Routes' }"
        >
          <TheIcons name="journey" />
        </router-link>
      </li>
      <li v-if="!storeAuth.isCourier" class="aside__menu-item">
        <router-link :to="{ name: 'Payments' }">
          <TheIcons name="money" />
        </router-link>
      </li>
      <li v-if="!storeAuth.isCourier" class="aside__menu-item">
        <router-link :to="{ name: 'Complaints' }">
          <TheIcons
            name="complaint"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          />
        </router-link>
      </li>
      <li v-if="!storeAuth.isCourier" class="aside__menu-item">
        <router-link :to="{ name: 'Leaves' }">
          <TheIcons name="vocation" />
        </router-link>
      </li>
      <li v-if="storeAuth.isAreaManager" class="aside__menu-item">
        <router-link :to="`/employee/${storeAuth.user.id}`">
          <TheIcons name="user" />
        </router-link>
      </li>
      <li class="aside__menu-item">
        <router-link :to="{ name: 'Users' }">
          <TheIcons
            name="settings"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          />
        </router-link>
      </li>
      <li class="aside__menu-item aside__menu-item--logout">
        <a href="#" @click.prevent="modal = true">
          <TheIcons name="logout" width="24" height="24" viewBox="0 0 24 24" />
        </a>
      </li>
    </ul>

    <app-modal
      v-model="modal"
      :icon="'logoutCircle'"
      :confirm="$t('button.logout')"
      @close="modal = false"
      @confirm="logout"
    >
      <div class="modal-title title-4">{{ $t('auth.login.logout_text') }}</div>
    </app-modal>
  </el-aside>
</template>

<script setup>
import { ref } from 'vue'
import { useAuthStore } from '@/store/auth'
import { useRouter } from 'vue-router'
import { useMediaQuery } from '@vueuse/core'
import TheIcons from '@/components/icons/TheIcons.vue'
import AppModal from '@/components/ui/modal/AppModal.vue'

const storeAuth = useAuthStore()
const router = useRouter()
const isTablet = useMediaQuery('(max-width: 768px)')

const modal = ref(false)

const logout = async () => {
  await storeAuth.logout()
  modal.value = false
  router.push('/sign-in')
}
</script>
